import React, { useContext } from 'react';
import styled from 'styled-components';
import { InputField } from '@ubeya/shared-web/components';
import { onlyPositiveNumber } from '@ubeya/shared/utils/form';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import useAccount from '@ubeya/shared/hooks/account/useAccount';
import { MARK_UP_TYPE_BY_ID } from './constants';

const PrefixText = styled.span`
  width: ${({ $length }) => ($length <= 1 ? '10px' : '20px')};
`;

const SupplierRatesFields = ({ isFlatWage, markupType, disableRateEdit, withMarkup = true }) => {
  const { t } = useContext(ConfigContext);
  const { account } = useAccount();
  const { supplierWage = {}, supplierClientWage = {} } = account?.payrollConfig || [];

  return (
    <>
      <>
        <InputField
          name="wage.hourlyWage"
          title={t('clientWage')}
          type="number"
          autoFocus
          onChange={parseFloat}
          readOnly={disableRateEdit}
          isDisabled={disableRateEdit}
          placeholder={disableRateEdit ? '' : `${t('default')} - ${supplierClientWage?.hourlyWage || 0}`}
        />
        {!disableRateEdit && (
          <InputField
            name="payrollWage.hourlyWage"
            title={t('specificClientPayRate')}
            type="number"
            min={0}
            onChange={onlyPositiveNumber}
            placeholder={`${t('default')} - ${supplierWage?.hourlyWage || 0}`}
          />
        )}

        {isFlatWage && (
          <>
            {!disableRateEdit && (
              <>
                <InputField
                  name="payrollWage.flatWage"
                  title={t('flatWage')}
                  onChange={onlyPositiveNumber}
                  type="number"
                  placeholder={`${t('default')} - ${supplierWage?.flatWage || 0}`}
                />
                <InputField
                  name="payrollWage.flatHours"
                  title={t('flatHours')}
                  onChange={onlyPositiveNumber}
                  type="number"
                  placeholder={`${t('default')} - ${supplierWage?.flatHours || 0}`}
                />
              </>
            )}
            <InputField
              name="wage.flatWage"
              title={t('globalWage')}
              readOnly={disableRateEdit}
              isDisabled={disableRateEdit}
              onChange={onlyPositiveNumber}
              type="number"
              placeholder={disableRateEdit ? '' : `${t('default')} - ${supplierClientWage?.flatWage || 0}`}
            />
            <InputField
              name="wage.flatHours"
              title={t('flatBillRateHoursLimit')}
              onChange={onlyPositiveNumber}
              readOnly={disableRateEdit}
              isDisabled={disableRateEdit}
              type="number"
              placeholder={disableRateEdit ? '' : `${t('default')} - ${supplierClientWage?.flatHours || 0}`}
            />
          </>
        )}
      </>

      {withMarkup && (
        <InputField
          name="markup.markup"
          title={
            <div>
              {t('markup')}
              {MARK_UP_TYPE_BY_ID[markupType] === 'percentage' && <PrefixText>(%)</PrefixText>}
            </div>
          }
          type="number"
          onChange={parseFloat}
        />
      )}
    </>
  );
};

export default SupplierRatesFields;
